import { useState } from 'react';
import PageContainerBlank from '../../components/PageContainer/PageContainerBlank.js';
import PageEndBlank from '../../components/PageContainer/PageEndBlank.js';
import FlexColumn from '../../components/FlexColumn/FlexColumn.js';
import FirstJoyfulMystery from '../../components/Mysteries/RosaryMysteries/FirstJoyfulMystery.js';
import SecondJoyfulMystery from '../../components/Mysteries/RosaryMysteries/SecondJoyfulMystery.js';
import ThirdJoyfulMystery from '../../components/Mysteries/RosaryMysteries/ThirdJoyfulMystery.js';
import FourthJoyfulMystery from '../../components/Mysteries/RosaryMysteries/FourthJoyfulMystery.js';
import FifthJoyfulMystery from '../../components/Mysteries/RosaryMysteries/FifthJoyfulMystery.js';
import FirstLuminousMystery from '../../components/Mysteries/RosaryMysteries/FirstLuminousMystery.js';
import SecondLuminousMystery from '../../components/Mysteries/RosaryMysteries/SecondLuminousMystery.js';
import ThirdLuminousMystery from '../../components/Mysteries/RosaryMysteries/ThirdLuminousMystery.js';
import FourthLuminousMystery from '../../components/Mysteries/RosaryMysteries/FourthLuminousMystery.js';
import FifthLuminousMystery from '../../components/Mysteries/RosaryMysteries/FifthLuminousMystery.js';
import FirstSorrowfulMystery from '../../components/Mysteries/RosaryMysteries/FirstSorrowfulMystery.js'
import SecondSorrowfulMystery from '../../components/Mysteries/RosaryMysteries/SecondSorrowfulMystery.js'
import ThirdSorrowfulMystery from '../../components/Mysteries/RosaryMysteries/ThirdSorrowfulMystery.js';
import FourthSorrowfulMystery from '../../components/Mysteries/RosaryMysteries/FourthSorrowfulMystery.js';
import FifthSorrowfulMystery from '../../components/Mysteries/RosaryMysteries/FifthSorrowfulMystery.js';
import FirstGloriousMystery from '../../components/Mysteries/RosaryMysteries/FirstGloriousMystery.js';
import SecondGloriousMystery from '../../components/Mysteries/RosaryMysteries/SecondGloriousMystery.js';
import ThirdGloriousMystery from '../../components/Mysteries/RosaryMysteries/ThirdGloriousMystery.js';
import FourthGloriousMystery from '../../components/Mysteries/RosaryMysteries/FourthGloriousMystery.js';
import FifthGloriousMystery from '../../components/Mysteries/RosaryMysteries/FifthGloriousMystery.js';
import { MYSTERY_GAP, MOBILE_MYSTERY_GAP } from '../../utils/Constants.js';

const RosaryCompanion = () => {
	const JOYFUL = "Joyful";
	const JoyfulMysteries = (
		<div>
			<h2>The Joyful Mysteries</h2>
			<br />
			<FlexColumn pcGap={MYSTERY_GAP} mobileGap={MOBILE_MYSTERY_GAP}>
				<FirstJoyfulMystery />
				<SecondJoyfulMystery />
				<ThirdJoyfulMystery />
				<FourthJoyfulMystery />
				<FifthJoyfulMystery />
			</FlexColumn>
		</div>
	);

	const LUMINOUS = "Luminous";
	const LuminousMysteries = (
		<div>
			<h2>The Luminous Mysteries</h2>
			<br />
			<FlexColumn pcGap={MYSTERY_GAP} mobileGap={MOBILE_MYSTERY_GAP}>
				<FirstLuminousMystery />
				<SecondLuminousMystery />
				<ThirdLuminousMystery />
				<FourthLuminousMystery />
				<FifthLuminousMystery />
			</FlexColumn>
		</div>
	);

	const SORROWFUL = "Sorrowful";
	const SorrowfulMysteries = (
		<div>
			<h2>The Sorrowful Mysteries</h2>
			<br />
			<FlexColumn pcGap={MYSTERY_GAP} mobileGap={MOBILE_MYSTERY_GAP}>
				<FirstSorrowfulMystery />
				<SecondSorrowfulMystery />
				<ThirdSorrowfulMystery />
				<FourthSorrowfulMystery />
				<FifthSorrowfulMystery />
			</FlexColumn>
		</div>
	);

	const GLORIOUS = "Glorious";
	const GloriousMysteries = (
		<div>
			<h2>The Glorious Mysteries</h2>
			<br />
			<FlexColumn pcGap={MYSTERY_GAP} mobileGap={MOBILE_MYSTERY_GAP}>
				<FirstGloriousMystery />
				<SecondGloriousMystery />
				<ThirdGloriousMystery />
				<FourthGloriousMystery />
				<FifthGloriousMystery />
			</FlexColumn>
		</div>
	);

	const EMPTY = "Empty";
	const EmptyMysteries = (
		<div></div>
	);

	const [mysterySet, setMysterySet] = useState(EmptyMysteries);
	const [mysteryKey, setMysteryKey] = useState(EMPTY);
	const handleChange = (event) => {
		switch (event.target.value) {
			case JOYFUL:
				setMysterySet(JoyfulMysteries);
				setMysteryKey(JOYFUL);
				break;
			case LUMINOUS:
				setMysterySet(LuminousMysteries);
				setMysteryKey(LUMINOUS);
				break;
			case SORROWFUL:
				setMysterySet(SorrowfulMysteries);
				setMysteryKey(SORROWFUL);
				break;
			case GLORIOUS:
				setMysterySet(GloriousMysteries);
				setMysteryKey(GLORIOUS);
				break;
			default:
				setMysterySet(EmptyMysteries);
				setMysteryKey(EMPTY);
				break;
		}
	}

	return (
		<div>
			<PageContainerBlank />

			<h1>Rosary Companion</h1>
			<p className="centered">
				Pick a set of mysteries from the dropdown:&nbsp;&nbsp;
				<select value={mysteryKey} onChange={handleChange}>
					<option value={EMPTY} disabled> -- Choose a set -- </option>
					<option value={JOYFUL}>The Joyful Mysteries</option>
					<option value={LUMINOUS}>The Luminous Mysteries</option>
					<option value={SORROWFUL}>The Sorrowful Mysteries</option>
					<option value={GLORIOUS}>The Glorious Mysteries</option>
				</select>
			</p>
			<br />
			{mysterySet}

			<PageEndBlank />
		</div>
	);
};

export default RosaryCompanion;